import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CanvasCard from '../../common/components/canvas-card';
import DomainManagementOverview from './domain-management-overview';

import { fetchDomainsOverview } from '../../common/actions/domains-overview-action-creators';
import { domainsOverviewIsLoading, domainsOverviewDataSelector } from '../../common/selectors/domains-overview-selectors';
import { openDomainManagementBulkPane } from '../../common/actions/right-pane-action-creators';

const cardHeaderConfig = {
    buttonText: 'Manage In Bulk',
    title: 'Domain Management',
};

export const DomainManagementOverviewContainer = ( {
    fetchDomainsOverview, domainsOverviewData, isLoading, match, openDomainManagementBulkPane
} ) => {
    useEffect( () => {
        fetchDomainsOverview();
    }, [fetchDomainsOverview] );

    return (
        <CanvasCard
            header={{
                ...cardHeaderConfig,
                buttonAction: () => openDomainManagementBulkPane()
            }}
            isLoading={isLoading}
            automationId="domain-mgt-overview"
        >
            <DomainManagementOverview
                data={domainsOverviewData}
                match={match}
            />
        </CanvasCard>
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => ( {
    domainsOverviewData: domainsOverviewDataSelector( state ),
    isLoading: domainsOverviewIsLoading( state ),
} );

const mapDispatchToProps = {
    fetchDomainsOverview,
    openDomainManagementBulkPane
};

DomainManagementOverviewContainer.propTypes = {
    domainsOverviewData: PropTypes.object.isRequired,
    fetchDomainsOverview: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
    openDomainManagementBulkPane: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, mapDispatchToProps )( DomainManagementOverviewContainer );
